<template>
  <div class="contents detail">
    <h2>社員マスタ 詳細</h2>
    <div class="container">

      <div class="maininfo">
        <div class="tabs">
          <scroll-tabs>
            <ul>
              <li :class="{ active: tab === TAB.BASIC }">
                <a @click="tab = TAB.BASIC">基本情報</a>
              </li>
              <li :class="{ active: tab === TAB.TENPU_DOWNLOAD }">
                <a @click="tab = TAB.TENPU_DOWNLOAD">添付ファイル</a>
              </li>
              <li :class="{ active: tab === TAB.LOGIN_QR }">
                <a @click="tab = TAB.LOGIN_QR">ログインQRの発行</a>
              </li>
              <li :class="{ active: tab === TAB.RESET_PASSWORD }">
                <a @click="tab = TAB.RESET_PASSWORD">パスワードリセット</a>
              </li>
              <li :class="{ active: tab === TAB.KOYOU_KEIYAKU }">
                <a @click="tab = TAB.KOYOU_KEIYAKU">雇用契約</a>
              </li>
              <li :class="{ active: tab === TAB.SYOUNIN_GROUP }">
                <a @click="tab =  TAB.SYOUNIN_GROUP">承認グループ</a>
              </li>
            </ul>
          </scroll-tabs>
        </div>
        <!-- /tabs -->

        <div class="tab-container">
          <parts-basic v-if="tab === TAB.BASIC"></parts-basic>
          <parts-download v-if="tab === TAB.TENPU_DOWNLOAD"></parts-download>
          <parts-login-qr v-if="tab === TAB.LOGIN_QR" :userId="userId"></parts-login-qr>
          <parts-reset-password v-if="tab === TAB.RESET_PASSWORD" :userId="userId"></parts-reset-password>
          <parts-koyoukeiyaku v-if="tab === TAB.KOYOU_KEIYAKU"></parts-koyoukeiyaku>
          <parts-syounin-group v-if="tab === TAB.SYOUNIN_GROUP"></parts-syounin-group>
        </div>
      </div>
      <!-- /maininfo -->
    </div>

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.SYAIN_LIST,
        }">検索画面に戻る
        </router-link>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useTab } from "@/composable/common/tab";
import PartsBasic from "@/components/syain/parts/Basic.vue";
import LoginQr from "@/components/qr/LoginQR.vue";
import PartsDownload from "@/components/syain/parts/Download.vue";
import PartsKoyouKeiyaku from "./parts/KoyouKeiyaku.vue";
import PartsSyouninGroup from "./parts/SyouninGroup.vue";
import ResetPassword from "./parts/ResetPassword.vue";
import { RouterConst } from "@/const/Router";
import { useRouter } from 'vue-router';
import { useSyainDetail } from "@/composable/syain/detail/init";

export default defineComponent({
  setup() {
    const TAB = {
      BASIC: 'basic',
      TENPU_DOWNLOAD: 'download',
      LOGIN_QR: 'login-qr',
      KOYOU_KEIYAKU: 'koyoukeiyaku',
      SYOUNIN_GROUP: 'syounin-group',
      RESET_PASSWORD: 'password-reset'
    }

    // タブの切替
    const { tab } = useTab(TAB.BASIC);
    const router = useRouter();
    const { userId  } = useSyainDetail()

    const changeTab = (v: string) => {
      tab.value = v
    }

    return {
      tab,
      RouterConst,
      router,
      changeTab,
      TAB,
      userId
    };
  },
  components: {
    "parts-basic": PartsBasic,
    "parts-download": PartsDownload,
    "parts-login-qr": LoginQr,
    "parts-koyoukeiyaku": PartsKoyouKeiyaku,
    "parts-syounin-group": PartsSyouninGroup,
    "parts-reset-password": ResetPassword,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>